import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface StudentUserContextProps {
  user: {
    email: string;
    phoneNumber: string;
    name: string;
    lastname: string;
  };
  updateUser: (user: Partial<StudentUserContextProps['user']>) => void;
}

const defaultState = {
  user: {
    email: '',
    phoneNumber: '',
    name: '',
    lastname: ''
  },
  updateUser: () => {}
};

const StudentUserContext = createContext<StudentUserContextProps>(defaultState);

export const useStudentUserContext = () => useContext(StudentUserContext);

interface UserProviderProps {
  children: ReactNode;
}

export const StudentUserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [user, setUser] = useState(defaultState.user);
  const STUDENT_USER_STORAGE_KEY = 'user';

  useEffect(() => {
    const storedUser = localStorage.getItem(STUDENT_USER_STORAGE_KEY);

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const updateUser = (newUserData: Partial<StudentUserContextProps['user']>): void => {
    setUser((prevUser) => {
      const updatedUser: StudentUserContextProps['user'] = { ...prevUser, ...newUserData };

      localStorage.setItem(STUDENT_USER_STORAGE_KEY, JSON.stringify(updatedUser));

      return updatedUser;
    });
  };

  return (
    <StudentUserContext.Provider value={{ user, updateUser }}>
      {children}
    </StudentUserContext.Provider>
  );
};

export default StudentUserProvider;
